import { APIClient } from './api-client.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { VersionDto } from './models/version-dto.model';

@Injectable()
export class VersionService {
  constructor(private api: APIClient) {}

  getLatestVersion(team: string): Observable<VersionDto> {
    return this.api.getLatestVersion({ team }).pipe(map((response) => response?.result));
  }
}
